export enum AppState {
  LOADING = "LOADING",
  START = "START",
  CHOOSE_EPOCH = "CHOOSE_EPOCH",
  PHOTO = "PHOTO",
  RESULT = "RESULT",
}
